import { render, staticRenderFns } from "./ProjectSkillView.vue?vue&type=template&id=8d2011ec&scoped=true"
import script from "./ProjectSkillView.vue?vue&type=script&lang=js"
export * from "./ProjectSkillView.vue?vue&type=script&lang=js"
import style0 from "./ProjectSkillView.vue?vue&type=style&index=0&id=8d2011ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2011ec",
  null
  
)

export default component.exports